export const formFieldDefaultOptions = {
  appearance: 'outline',
  floatLabel: 'auto',
  hideRequiredMarker: false,
};
